import store from '@/store'

function display(message, type) {
  if (message) {
    store.commit('Alert/set', {
      message: message,
      type: type || 'info',
    })
  }
}

function error(message) {
  display(message, 'error')
}

function success(message) {
  display(message, 'success')
}

function info(message) {
  display(message, 'info')
}

export default {
  display,
  error,
  success,
  info,
}
